import axios from "axios";

export const putImportFileService = async (signedUrl: string, file: File): Promise<void> => {
  await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": "application/octet-stream"
    }
  });
};
